import {
  Company,
  Income,
  Miner,
  Share,
  UserProfile,
  Withdraw,
  WithdrawState
} from "@/interfaces";
import { MainState, AppNotification } from "./state";
import { getStoreAccessors } from "typesafe-vuex";
import { State } from "../state";

export const mutations = {
  setToken(state: MainState, payload: string) {
    state.token = payload;
  },
  setImage(state: MainState, payload: Blob | null) {
    state.image = payload;
  },
  setMiners(state: MainState, payload: Miner[]) {
    state.miners = payload;
  },
  setMiner(state: MainState, payload: Miner) {
    const miners = state.miners.filter(
      (miner: Miner) => miner.id !== payload.id
    );
    miners.push(payload);
    state.miners = miners;
  },
  setWithdraws(state: MainState, payload: Withdraw[]) {
    state.withdraws = payload;
  },
  setWithdraw(state: MainState, payload: Withdraw) {
    const withdraws = state.withdraws.filter(
      (withdraw: Withdraw) => withdraw.id !== payload.id
    );
    withdraws.push(payload);
    state.withdraws = withdraws;
  },
  setWithdrawStates(state: MainState, payload: WithdrawState[]) {
    state.withdrawStates = payload;
  },
  setShares(state: MainState, payload: Share[]) {
    state.shares = payload;
  },

  setCalling(state: MainState, calling: boolean) {
    state.calling = calling;
  },
  setMinerShares(
    state: MainState,
    payload: { minerId: number; shares: Share[] }
  ) {
    const miner = state.miners.find(
      (miner: Miner) => miner.id === payload.minerId
    );
    miner!.shares = payload.shares;
  },
  setMobile(state: MainState, payload: string) {
    state.mobile = payload;
  },
  setLoggedIn(state: MainState, payload: boolean) {
    state.isLoggedIn = payload;
  },
  setTokenSent(state: MainState, payload: boolean) {
    state.isTokenSent = payload;
  },
  setLogInError(state: MainState, payload: boolean) {
    state.logInError = payload;
  },
  setUserProfile(state: MainState, payload: UserProfile) {
    state.userProfile = payload;
  },
  setDashboardMiniDrawer(state: MainState, payload: boolean) {
    state.dashboardMiniDrawer = payload;
  },
  setDashboardShowDrawer(state: MainState, payload: boolean) {
    state.dashboardShowDrawer = payload;
  },
  addNotification(state: MainState, payload: AppNotification) {
    state.notifications.push(payload);
  },
  removeNotification(state: MainState, payload: AppNotification) {
    state.notifications = state.notifications.filter(
      (notification) => notification !== payload
    );
  },setIncomes(state: MainState, payload: Income[]) {
    state.incomes = payload;
  },setCompanies(state: MainState, payload: Company[]) {
    state.companies = payload;
  },setLicenceAccepted(state: MainState, payload: boolean) {
    state.isLicenceAccepted = payload;
  }
};

const { commit } = getStoreAccessors<MainState | any, State>("");

export const commitSetDashboardMiniDrawer = commit(
  mutations.setDashboardMiniDrawer
);
export const commitSetDashboardShowDrawer = commit(
  mutations.setDashboardShowDrawer
);
export const commitSetTokenSent = commit(mutations.setTokenSent);
export const commitSetLoggedIn = commit(mutations.setLoggedIn);
export const commitSetLogInError = commit(mutations.setLogInError);
export const commitSetToken = commit(mutations.setToken);
export const commitSetMobile = commit(mutations.setMobile);
export const commitSetUserProfile = commit(mutations.setUserProfile);

export const commitAddNotification = commit(mutations.addNotification);
export const commitRemoveNotification = commit(mutations.removeNotification);

export const commitSetMiners = commit(mutations.setMiners);
export const commitSetMiner = commit(mutations.setMiner);

export const commitSetImage = commit(mutations.setImage);

export const commitSetWithdraws = commit(mutations.setWithdraws);
export const commitSetWithdraw = commit(mutations.setWithdraw);
export const commitSetWithdrawStates = commit(mutations.setWithdrawStates);

export const commitSetShares = commit(mutations.setShares);
export const commitSetMinerShares = commit(mutations.setMinerShares);

export const commitSetCalling = commit(mutations.setCalling);

export const commitSetIncomes = commit(mutations.setIncomes);
export const commitSetCompanies = commit(mutations.setCompanies);
export const commitSetLicenceAccepted = commit(mutations.setLicenceAccepted);
